import React, { Component } from 'react'
import { InView } from 'react-intersection-observer'

interface InViewFrameProps {
  children?: React.ReactNode
  enabled?: boolean
  onChange?(...args: unknown[]): unknown
  root?: any
}

class InViewFrame extends Component<InViewFrameProps> {
  static displayName = 'InViewFrame'
  static defaultProps = {
    enabled: true,
    onChange: () => {},
    root: global.document.documentElement
  }

  render() {
    const { onChange, root, children, enabled } = this.props
    if (enabled) {
      return (
        <InView onChange={onChange} root={root} threshold={0} rootMargin={'0px'} data-testid="InView">
          {children}
        </InView>
      )
    } else {
      return children
    }
  }
}

export default InViewFrame
